"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteConversationOutputDtoSchema = exports.deleteConversationInputDtoSchema = void 0;
const zod_1 = require("zod");
const conversation_summary_dto_js_1 = require("./conversation-summary.dto.js");
exports.deleteConversationInputDtoSchema = zod_1.z.object({
    conversationId: conversation_summary_dto_js_1.agentChatConversationIdSchema,
});
exports.deleteConversationOutputDtoSchema = zod_1.z.object({
    conversationId: zod_1.z.string(),
});
//# sourceMappingURL=delete-conversation.dto.js.map